const SCHEDULE_SELECTOR = '[data-announcement-schedule]';

function parseScheduledDate(value, timeZone) {
  const trimmed = String(value || '').trim();

  if (/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:?\d{2})$/.test(trimmed)) {
    const parsed = new Date(trimmed);

    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }

  const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);

  if (!match) return undefined;

  const [, year, month, day, hour = '00', minute = '00'] = match;
  const utcGuess = new Date(Date.UTC(+year, +month - 1, +day, +hour, +minute));
  const offset = getTimeZoneOffset(utcGuess, timeZone);

  return new Date(utcGuess.getTime() - offset);
}

function getTimeZoneOffset(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);

  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const asUtc = Date.UTC(
    Number(values.year),
    Number(values.month) - 1,
    Number(values.day),
    Number(values.hour),
    Number(values.minute),
    Number(values.second)
  );

  return asUtc - date.getTime();
}

function isSlideActive(slide, now = new Date()) {
  if (slide.dataset.scheduleEnabled !== 'true') return true;

  const timeZone = slide.dataset.scheduleTimeZone || 'Europe/Madrid';
  const start = parseScheduledDate(slide.dataset.scheduleStart, timeZone);
  const end = parseScheduledDate(slide.dataset.scheduleEnd, timeZone);

  if (start && now < start) return false;
  if (end && now > end) return false;

  return true;
}

function updateAnnouncementBar(bar) {
  const slides = [...bar.querySelectorAll(SCHEDULE_SELECTOR)];
  if (!slides.length) return;

  const now = new Date();
  let firstVisibleIndex = -1;

  slides.forEach((slide, index) => {
    const visible = isSlideActive(slide, now);
    slide.hidden = !visible;

    if (visible && firstVisibleIndex === -1) {
      firstVisibleIndex = index;
    }
  });

  const hasVisibleSlides = firstVisibleIndex !== -1;
  bar.dataset.scheduleReady = 'true';
  bar.hidden = !hasVisibleSlides;

  const background = bar.previousElementSibling;
  if (background?.classList.contains('section-background')) {
    background.dataset.scheduleReady = 'true';
    background.hidden = !hasVisibleSlides;
  }

  if (!hasVisibleSlides) return;

  const slider = bar.querySelector('announcement-bar-component');
  if (slider && typeof slider.current === 'number') {
    slider.current = firstVisibleIndex;
  } else {
    slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', `${index !== firstVisibleIndex}`);
    });
  }
}

function updateScheduledAnnouncements() {
  document.querySelectorAll('.announcement-bar').forEach(updateAnnouncementBar);
}

updateScheduledAnnouncements();
document.addEventListener('DOMContentLoaded', updateScheduledAnnouncements);
document.addEventListener('shopify:section:load', updateScheduledAnnouncements);
setInterval(updateScheduledAnnouncements, 60 * 1000);
